var map = {
	"./boost-your-post-for-increasing-sales.md": 95,
	"./difference-between-gatsbyjs-and-nextjs.md": 96,
	"./future-of-javascript.md": 97,
	"./how-to-choose-javascript-framework-for-project.md": 98,
	"./how-to-get-10k-instagram-followers.md": 99,
	"./installing-nodejs-on-your-device.md": 100,
	"./markdown-html-supported-blog.md": 101,
	"./popular-javascript-library-in-2020.md": 102,
	"./programmers-must-read-books.md": 103,
	"./think-out-of-the-box.md": 104,
	"./time-to-use-latest-technology-for-creating-a-website.md": 105,
	"./trending-designs-in-2020.md": 106,
	"./uiux-design-starter-with-adobe-xd.md": 107,
	"./web-automation-with-python-language.md": 108,
	"./what-nodejs-can-do.md": 109
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94;